export default "__VITE_ASSET__C9x6HbC4__"